__turbopack_context__.v({
  "pluginBox": "PluginSidebarBox-module__7GHDIW__pluginBox",
  "pluginBoxBadge": "PluginSidebarBox-module__7GHDIW__pluginBoxBadge",
  "pluginBoxBadgeDot": "PluginSidebarBox-module__7GHDIW__pluginBoxBadgeDot",
  "pluginBoxCollapsed": "PluginSidebarBox-module__7GHDIW__pluginBoxCollapsed",
  "pluginBoxHeader": "PluginSidebarBox-module__7GHDIW__pluginBoxHeader",
  "pluginBoxIcon": "PluginSidebarBox-module__7GHDIW__pluginBoxIcon",
  "pluginBoxInvalidBadge": "PluginSidebarBox-module__7GHDIW__pluginBoxInvalidBadge",
  "pluginBoxItem": "PluginSidebarBox-module__7GHDIW__pluginBoxItem",
  "pluginBoxLabel": "PluginSidebarBox-module__7GHDIW__pluginBoxLabel",
  "pluginBoxLink": "PluginSidebarBox-module__7GHDIW__pluginBoxLink",
  "pluginBoxLinkActive": "PluginSidebarBox-module__7GHDIW__pluginBoxLinkActive",
  "pluginBoxLinkCollapsed": "PluginSidebarBox-module__7GHDIW__pluginBoxLinkCollapsed",
  "pluginBoxLinkDisabled": "PluginSidebarBox-module__7GHDIW__pluginBoxLinkDisabled",
  "pluginBoxLinkInvalid": "PluginSidebarBox-module__7GHDIW__pluginBoxLinkInvalid",
  "pluginBoxList": "PluginSidebarBox-module__7GHDIW__pluginBoxList",
  "pluginBoxTitle": "PluginSidebarBox-module__7GHDIW__pluginBoxTitle",
});
